export const GET_STOCK_AVAILABILITY_REQUEST = "GET_STOCK_AVAILABILITY_REQUEST";
export const GET_STOCK_AVAILABILITY_SUCCESS = "GET_STOCK_AVAILABILITY_SUCCESS";
export const GET_STOCK_AVAILABILITY_FAILURE = "GET_STOCK_AVAILABILITY_FAILURE";

export const DOWNLOAD_STOCK_AVAILABILITY_REQUEST =
  "DOWNLOAD_STOCK_AVAILABILITY_REQUEST";
export const DOWNLOAD_STOCK_AVAILABILITY_SUCCESS =
  "DOWNLOAD_STOCK_AVAILABILITY_SUCCESS";
export const DOWNLOAD_STOCK_AVAILABILITY_FAILURE =
  "DOWNLOAD_STOCK_AVAILABILITY_FAILURE";
